/**
 * Created by Kristy on 02/09/2019.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('schedulesAll', {
                parent: 'adminIndex',
                url: '/schedules/all',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT', 'ROLE_SUPERVISOR']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/schedulesAll/schedulesAll.html',
                        controller: 'SchedulesAllController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                                        "field": "viewName", "operator": "eq",
                                        "value": "schedules"
                                    }] } }} );
                    }],
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
